export const FETCH_ORG_MODULES = `
  query findOrgModules($orgId: ID!) {
    org_modules(
      where: {
        org_pointer: { have: { objectId: { equalTo: $orgId } } }
        enabled: { equalTo: true }
      }
    ) {
      edges {
        node {
          objectId
          module_pointer {
            objectId
            name
            price_for_quantity
            included_quantity
            included_service_relation {
              edges {
                node {
                  objectId
                  name
                }
              }
            }
          }
          enabled
        }
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");
